import { viewSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const exportInventoryLevels = {
  name: "exportInventoryLevels" as const,
  input: z.object({
    view: viewSchemas["inventory-levels"],
    locationId: z.string().optional(),
    sendToEmail: z.string().email().optional(),
  }),
  output: z.object({ exportId: z.string(), fileUrl: z.string().optional() }),
};
